module.exports = __webpack_public_path__ + "static/media/9.ac29f02d.png";